import { Card, CardHeader } from "../../components/shadcn-ui/card";
import { Link } from "react-router-dom";

interface SalesCardProps {
  title: string;
  icon: string;
  bgColor: string;
  linkTo: string;
}

export const SalesCard: React.FC<SalesCardProps> = ({
  title,
  icon,
  bgColor,
  linkTo,
}) => (
  <Link to={linkTo}>
    <Card
      className={`${bgColor} rounded-3xl shadow flex pb-0 flex-col justify-between h-full items-center cursor-pointer`}
    >
      <CardHeader className="text-lg pb-4 font-semibold">{title}</CardHeader>
      <div className="icon mb-2">
        <img src={icon} alt="" />
      </div>
    </Card>
  </Link>
);
